export const arr1 = [
  { text: 'Сначала необходимо выбрать приемлемую частоту дискретизации звуковой волны, т.е. то количество отрезков, на которое будет разбита каждая секунда волны.' },
  { text: 'Она зависит от диапазона частот звуков музыкального файла.' },
  { text: 'Важно, чтобы не была потеряна ни одна ключевая точка волны!' },
  { text: 'Задание: с помощью ползунков слева подобрать частоту дискретизации для каждой волны таким образом, чтобы каждая ключевая точка была на отдельном участке (ползунки станут зелеными только при нужном значении).', buttonTitle: 'Начать', step: 'start' },
]

export const arr2 = [
  { text: 'Минимальная частота дискретизации для качественной оцифровки зависит от максимальной частоты сигнала. Думаю, ты заметил зависимость.' },
  { text: 'Задание: в формуле зависимости минимальной частоты дискретизации для оцифровки от максимальной частоты сигнала впиши пропущенный множитель.' },
  { text: 'A - минимальная частота дискретизации для оцифровки <br> В - максимальная частота сигнала', maxWidthNone: true, step: 'input' },
]

export const arr3 = [
  { text: 'Отлично! Продолжаем наше путешествие.', buttonTitle: 'Продолжить' },
]

export const hint = [
  { text: 'Отметь точки, где машина поворачивает.' },
]


export const extraMessage = [
  { text: 'Если хочешь посмотреть задание еще раз, просто наведи курсор на меня!', highlight: true, buttonTitle: 'Понятно' },
]

export const task1 = [
  { text: 'Задание: с помощью ползунков слева подобрать частоту дискретизации для каждой волны таким образом, чтобы каждая ключевая точка была на отдельном участке (ползунки станут зелеными только при нужном значении).' },
]

export const finish = [
  { text: 'Верно!' },
]
